import { HTMLChakraProps, chakra, forwardRef } from '@chakra-ui/react'

export interface FormProps extends HTMLChakraProps<'form'> {}

const Form = forwardRef<FormProps, 'form'>((props, ref) => {
  return <chakra.form ref={ref} {...props} />
})

export default Form
